import { Business } from '../business';

export type Franchise = {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  businesses?: Business[];
};

export interface PaginatedFranchiseResponse {
  franchises: Franchise[];
  page: number;
  count: number;
}

export interface CreateFranchiseDTO {
  name: string;
}

export interface AddBusinessesDTO {
  franchiseId: number;
  businessIds: number[];
}

export interface RemoveBusinessesDTO {
  franchiseId: number;
  businessIds: number[];
}

export const exampleFranchise: Franchise = {
  id: 0,
  name: 'Example Franchise',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};
